/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

export enum AddedByType {
  DOCTOR = 'DOCTOR',

  NURSE = 'NURSE',

  MANAGER = 'MANAGER',

  LAB_ASSISTANT = 'LAB_ASSISTANT',

  HOSPITAL_ASSISSTANT = 'HOSPITAL_ASSISSTANT',

  LAB = 'LAB',

  ACCOUNTANT = 'ACCOUNTANT',
}
